import { useMemo } from 'react';
import { SelectPicker } from 'rsuite';
import { getLimitOptions } from '../utils/pagination';

export const SelectItemsPerPage = ({ totalItems, itemsPerPage, onChange }) => {
  const options = useMemo(() => getLimitOptions(totalItems), [totalItems]);
  const data = useMemo(() => options.map((n) => ({ label: `Show ${n} per page`, value: n })), [options]);

  // Clamp the displayed value to one of the current options (mirrors
  // DevicesTable's effectiveLimit) so the picker always shows a real value
  // instead of a blank "Select" placeholder when itemsPerPage isn't among
  // the row-count-scaled options.
  const effectiveValue = options.includes(itemsPerPage) ? itemsPerPage : options[options.length - 1];

  return <SelectPicker data={data} value={effectiveValue} onChange={onChange} searchable={false} cleanable={false} />;
};
